module.exports = __webpack_public_path__ + "img/fl_pic.13bf6cfb.png";